import { isEmpty, not, pipe } from 'ramda';
import React from 'react';
import { compact } from 'ramda-adjunct';

export const hasChildrenToRender = pipe(React.Children.toArray, compact, isEmpty, not);
